import React from 'react';

import { connectWithStore } from '@common/connectWithStore';
import {
  UserDetails,
  UserDetailsDispatchProps,
  UserDetailsOwnProps,
  UserDetailsStateProps,
} from '@react/Pages/AccountSettingsPage/UserDetails/UserDetails/UserDetails';
import { getCurrentUser } from '@redux/ducks/global';
import {
  closeAlert,
  closeConfirm,
  fetchUserDetails,
  getUserDetailsState,
  isAccountOwner,
  resetState,
  showConfirm,
  updateUser,
  deleteUser,
} from '@redux/ducks/userDetails/userDetails';
import { getTimezonesOptions } from '@redux/ducks/accountDetails';

const mapStateToProps = (state): UserDetailsStateProps => {
  const { user, isLoading, trace, isAlertOpen, isDisabled, isConfirmOpen } = getUserDetailsState(state);

  return {
    user,
    isLoading,
    trace,
    isAlertOpen,
    isConfirmOpen,
    isDisabled,
    currentUser: getCurrentUser(state),
    isAccountOwner: isAccountOwner(state),
    timezones: getTimezonesOptions(state),
  };
};

const mapDispatchToProps: UserDetailsDispatchProps = {
  fetchUserDetails,
  resetState,
  updateUser,
  closeAlert,
  showConfirm,
  closeConfirm,
  deleteUser,
};

export const UserDetailsContainer: React.FC<UserDetailsOwnProps> = connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(UserDetails);
